import React, { useState, useEffect } from 'react';
import Header from '../../components/Header';
import api from '../../services/api_adiantamento';
import apidesp from '../../services/api_despesas';
import styles from "./styles.module.css";
import { BsFillPlusCircleFill } from "react-icons/bs";
import { useHistory } from "react-router-dom";

export default function Dashboards() {

    const [image, setImage] = useState('');
    const [modalCategoriaOpen, setModalCategoriaOpen] = useState(false);
    const [descricao, setDescricao] = useState('');
    const [categorias, setCategorias] = useState([]);
    const [isControladoria, setIsControladoria] = useState(false);
    const [atualizar, setAtualizar] = useState(true);
    const [salvando, setSalvando] = useState(false);


    let history = useHistory();

    useEffect(() => {
        if (atualizar) {
            api.get(`/dashboards/categorias`).then(function (response) {
                if (response.data) {
                    setCategorias(response.data)
                }
            }).catch(function (error) {
                // handle error
                console.log(error);
            }).then(function () {
                // always executed
                setAtualizar(false);
            });
        }
    }, [atualizar]);

    useEffect(() => {
        apidesp.get(`/usuario/getPerfilByUser`).then(function (response) {
            if (response.data) {
                if (response.data.usuario_perfil) {
                    response.data.usuario_perfil.forEach((perf, index) => {
                        if (parseInt(perf.perfil_id) === 5) {
                            setIsControladoria(true);
                            return;
                        }

                    })
                }
            }
        }).catch(function (error) {
            // handle error
            alert(error);
            console.log(error);
        }).then(function () {
            // always executed
        });

    }, []);

    function handleUpload() {
        if (!salvando) {
            setSalvando(true);

            let anexo = new FormData();
            anexo.append('file', image);
            anexo.append('descricao', descricao);

            api.post('/dashboards/', anexo).then(function (response) {
                if (response.data) {
                    setModalCategoriaOpen(false);
                    setImage('');
                    setDescricao('');
                    setAtualizar(true);
                }
            }).catch(function (error) {
                // handle error
                console.log(error);
            }).then(function () {
                // always executed
                setSalvando(false);
            });
        }
    }

    function fechaModalCategoria() {
        setModalCategoriaOpen(false);
    }

    function renderImagem() {
        if (image) {
            const file = URL.createObjectURL(image);

            return (
                <div className={styles.previaimg}>
                    <img src={file} className={styles.contentimage} />
                    <h4>{descricao}</h4>
                </div>
            )
        }
    }

    function renderModalNovaCategoria() {
        return (
            <div
                className={(modalCategoriaOpen ? "modal-despesas" : "modal-fechado")}
            >
                <span
                    className="fechar-modal-previsoes"
                    onClick={() => fechaModalCategoria()}
                ><b>x</b></span>
                <div>
                    <h3><b>CADASTRAR NOVA CATEGORIA</b></h3>

                </div>
                <div className={styles.bodydashboard}>
                    <div className={styles.Dashboardselements}>
                        <label>DESCRIÇÃO</label>
                        <input type="text" value={descricao} onChange={(e) => setDescricao(e.target.value)} />
                    </div>
                    <div className={styles.Dashboardselements}>
                        <label>IMAGEM</label>
                        <input type="file" accept="image/*," name="imagem" onChange={(e) => setImage(e.target.files[0])} className={styles.lblimg} />
                    </div>
                    PRÉVIA
                    {renderImagem()}
                    <input type="button" value="enviar" onClick={() => handleUpload()} className="btn btn-primary" />
                </div>
            </div>
        )
    }

    function handleClickCategoria(id) {
        history.push(`dashboards/categoria/${id}`);
    }


    function renderCategorias() {
        return (
            categorias.map((cat, index) => {
                return (
                    <div className={styles.renderimg} onClick={() => handleClickCategoria(cat.id)} key={index}>
                        <img src={cat.url} className={styles.contentimageexibicao} />
                        <p className={styles.textimg}>{cat.descricao}</p>
                    </div>
                )
            })
        )

    }
    function renderNew() {
        if (isControladoria) {
            return (
                <div>
                    <BsFillPlusCircleFill
                        onClick={() => setModalCategoriaOpen(true)}
                        size="50"
                        color='green'
                        className={styles.newcategoria}
                    />

                </div>
            )
        } else {
            return (<></>)
        }
    }

    return (
        <>
            {renderModalNovaCategoria()}
            <div className="container-lg">
                <Header title="DASHBOARDS" />
                {renderNew()}
                <div className={styles.categorias}>
                    {renderCategorias()}
                </div>

            </div>

        </>
    )
}